import { Link } from 'react-router-dom';
import { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group relative block rounded-lg overflow-hidden h-48 cursor-pointer"
    >
      <img
        src={category.imageUrl}
        alt={category.name}
        title={`${category.name} - ${category.description.slice(0, 50)}`}
        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/40 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="w-6 h-6 flex items-center justify-center">
            <i className={`${category.icon} text-accent-500 text-base`}></i>
          </span>
          <h3 className="text-base font-semibold font-heading text-foreground-950">
            {category.name}
          </h3>
        </div>
        <p className="text-xs text-foreground-500 line-clamp-1">{category.description}</p>
        <span className="inline-block mt-2 text-xs text-accent-500">
          {category.articleCount} 篇文章
        </span>
      </div>
    </Link>
  );
}